import { ChangeDetectionStrategy, Component, HostBinding, inject, Input } from '@angular/core';

import { NEW_DESIGN } from '@kros-sk/core/design-version';
import { TooltipDirective } from '@kros-sk/ui/tooltip';

import { SaveIndicatorState } from './save-indicator.interface';

@Component({
  selector: 'kros-save-indicator',
  templateUrl: './save-indicator.component.html',
  styleUrls: ['./save-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective],
})
export class SaveIndicatorComponent {
  @Input() state!: SaveIndicatorState;
  @Input() savingTooltip = 'Ukladá sa ...';
  @Input() savedTooltip = 'Uložené';

  protected newDesign = inject(NEW_DESIGN, { optional: true });

  @HostBinding('class.new-design') get newDesignClass(): boolean {
    return Boolean(this.newDesign);
  }

  get savedIconVisible(): boolean {
    return this.state === SaveIndicatorState.Saved;
  }

  get inProgressIconVisible(): boolean {
    return this.state === SaveIndicatorState.InProgress;
  }
}
